import { crmStatusLabels } from "../../@types/sharedSchema";
import { mappedCustomerTypes } from "utils/contacts/mappedTs";

/**
 * The NAMES of the leads-import grid's columns, and the value sets two of them accept.
 *
 * Split out of `RealEstateCrmSpecifications.tsx` so the import VALIDATIONS can share them
 * without importing that file. The column definitions there carry `cellRenderer`s and pull
 * in the app's React tree, which drags `firebaseConfig` and an ESM-only dependency behind
 * it — enough that a unit test of the validators could not load, so the validators had no
 * tests at all. That is how an unconditional `parsedRow.customerBudget = ""` sat there
 * silently wiping the budget of any file whose header it did not recognise.
 *
 * The column definitions import these constants, so the two cannot drift: a header renamed
 * here is renamed in the grid, and the validator that keys on it keeps working.
 */

export const CONTACT_IMPORT_COLUMN_NAMES = {
  customerBudget: { field: "customerBudget", header: "תקציב" },
  roomsMin: { field: "roomsMin", header: "חדרים - מ" },
  roomsMax: { field: "roomsMax", header: "חדרים - עד" },
  customerType: { field: "customerType", header: "סוג לקוח" },
  crmStatus: { field: "crmStatus", header: "סטטוס" }
} as const;

/** Hebrew customer-type labels, as they appear in a file and in the grid's editor. */
export const customerTypePossibleValues = Object.keys(mappedCustomerTypes);

/**
 * CRM v2 lifecycle statuses as their Hebrew LABELS — what a person types in a file and
 * picks in the grid. Converted to `CrmStatus` ids at save time via `crmStatusFromLabel`.
 */
export const crmStatusPossibleValues = Object.values(crmStatusLabels);

export const optedOutOfBulkMessagesPossibleValues = ["", false, true];
